import React from 'react';
import * as Mui from '@mui/material';
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { FeatherIcon } from "component/shared/feather-icon";
import { styles } from './style';

interface Props extends OwnProps,
	WithStyles<typeof styles> {
}

interface OwnProps {
	icon?: React.ReactNode,
	action?: React.ReactNode,
	children?: React.ReactNode,
}

class MyComponent extends React.Component<Props> {
	constructor(props: Props) {
		super(props);
		this.state = {
			
		};
	}

	render() {
		const { action, icon, children, classes = {} } = this.props;
		return (
			<Mui.Grid container alignItems="center" spacing={1}>
				<Mui.Grid item xs={1} className={classes.iconContainer}>
					{icon && (
						<FeatherIcon>
							<>{icon}</>
						</FeatherIcon>
					)}
					
				</Mui.Grid>
				<Mui.Grid item xs>
					{children}
				</Mui.Grid>
				<Mui.Grid item xs={1} className={classes.iconContainer}>
					{action && (
						<>{action}</>
					)}
				</Mui.Grid>
			</Mui.Grid>
		);
	}
}

export const Row = withStyles(MyComponent, styles);